module.exports = __webpack_public_path__ + "static/media/Dartrix_gaussian2.cc92192e.png";